export enum ActivityFeedItemType {
  Objective = 1,
  Incident = 2,
  Objective_Group = 3,
  Risk = 4,
  Incident_Logs = 9,
  PEAP_Checks = 10,
}
